import React from "react";
import DataTablePage from "@/components/common/DataTablePage";

export default function CompetitorsPage() {
  return (
    <DataTablePage
      collection="competitors"
      eyebrow="Market Intel"
      title="Competitor Tracking"
      subtitle="Track competitor brands — their positioning, offers and channels — so your AI team can counter-program your campaigns."
      emptyDefault={{ threat: "medium" }}
      columns={[
        { key: "name", label: "Competitor", type: "text" },
        { key: "channel", label: "Main Channels", type: "text" },
        { key: "threat", label: "Threat", type: "badge", options: ["high", "medium", "low"] },
        { key: "notes", label: "Notes", type: "textarea" },
      ]}
    />
  );
}
